<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
    <el-row>
      <el-col :span="12" v-if="moduletag !== 2">
        <el-form-item label="所属组织" prop="">
          <el-cascader v-fixZoom style="width: 100%" :options="treeData" v-model="addEditForm.orgid" :filterable="true" placeholder="请选择所属组织" clearable
                       :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}" ref="orgOptions" @change="selectOrgId">
          </el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="moduletag !== 2">
        <el-form-item :label="'所属' + labelCommunity" prop="">
          <el-select v-fixZoom style="width: 100%" clearable v-model="addEditForm.cid" filterable :placeholder="`请选择` + labelCommunity" @change="selectCommunityID">
            <el-option v-for="item in orgcommunitys" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
<!--      <el-col :span="12" v-if="moduletag !== 2">-->
<!--        <el-form-item :label="'所属' + labelHome" prop="">-->
<!--          <el-select v-fixZoom style="width: 100%" clearable filterable v-model="addEditForm.hid" :placeholder="`请选择` + labelHome">-->
<!--            <el-option v-for="item in selectorghomes" :key="item.id" :label="item.address" :value="item.id">-->
<!--              <span style="">{{ item.address }}</span>&nbsp;-->
<!--              <span style="color: #8492a6; font-size: 12px">{{ item.telephone }}</span>-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--      </el-col>-->
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item :label="nameshow" prop="name">
          <el-select v-fixZoom v-model="nametype" filterable placeholder="请选择" :clearable="true" style="width:100%;" @change="changeName">
            <el-option v-for="(item, index) in nameArr" :key="index" :label="item" :value="item"></el-option>
          </el-select>
          <el-input v-if="nametype === '其他'" style="width: 100%" v-model="addEditForm.name" placeholder="请输入其他活动名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="timeshow" prop="event_time">
          <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.event_time" :clearable="false"
                          type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item :label="descshow" prop="desc">
          <el-input v-model="addEditForm.desc" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="地点" prop="location">
          <el-input v-model="addEditForm.location" placeholder="请输入地点"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="承办部门" prop="">
          <el-input v-model="addEditForm.department" placeholder="请输入承办部门"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="召集人" prop="promoter">
          <el-input v-model="addEditForm.promoter" placeholder="请输入召集人"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="记录人" prop="recorder">
          <el-input v-model="addEditForm.recorder" placeholder="请输入记录人"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="参与人" prop="participantArr">
      <el-tag :key="tag" v-for="tag in addEditForm.participantArr" :closable="addEditObj.isAdd" :disable-transitions="false" @close="handleClose1(tag)">
        {{tag}}
      </el-tag>
      <el-input style="width: 100px" class="input-new-tag" v-if="inputVisible" v-model="inputValue"
                ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm">
      </el-input>
      <el-button v-else class="button-new-tag" size="small" @click="showInput"> + </el-button>
    </el-form-item>
    <el-form-item label="签到照片" prop="">
      <div>
        <el-upload class="upload-img" action="#" list-type="picture-card" accept=".png,.jpg,jpeg"
                   :auto-upload="false" :on-preview="handlePictureCardPreview"
                   :on-remove="handleRemove" :on-success="handleSuccess" :on-error="handleError"
                   :on-change="handleChange" :limit="5"  :file-list="dialogImageUrlArray" ref="upload">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" width="800px" append-to-body>
          <div style="text-align: center">
            <img style="max-width: 100%" :src="dialogImageUrl" alt="">
          </div>
        </el-dialog>
      </div>
    </el-form-item>
    <el-form-item label="现场照片" prop="">
      <div>
        <el-upload class="upload-img" action="#" list-type="picture-card" accept=".png,.jpg,jpeg"
                   :auto-upload="false" :on-preview="handlePictureCardPreview1"
                   :on-remove="handleRemove1" :on-success="handleSuccess" :on-error="handleError"
                   :on-change="handleChange1" :limit="5" :file-list="dialogImageUrlArray1" ref="upload1">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible1" width="800px" append-to-body>
          <div style="text-align: center">
            <img style="max-width: 100%" :src="dialogImageUrl1" alt="">
          </div>
        </el-dialog>
      </div>
    </el-form-item>
    <el-form-item label="计划方案照片" prop="">
      <div>
        <el-upload class="upload-img" action="#" list-type="picture-card" accept=".png,.jpg,jpeg"
                   :auto-upload="false" :on-preview="handlePictureCardPreview2"
                   :on-remove="handleRemove2" :on-success="handleSuccess" :on-error="handleError"
                   :on-change="handleChange2" :limit="5" :file-list="dialogImageUrlArray2" ref="upload2">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible2" width="800px" append-to-body>
          <div style="text-align: center">
            <img style="max-width: 100%" :src="dialogImageUrl2" alt="">
          </div>
        </el-dialog>
      </div>
    </el-form-item>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
  <el-dialog :visible.sync="addShow" v-if="addShow" width="500px"
             :show-close="true" :close-on-click-modal="false" center class="all-open" append-to-body>
    <div class="title-top-alarm">
      <span>参与人</span>
      <div class="line-title"></div>
      <div style="margin-top: 20px">
        <el-form style="margin-right: 30px" :model="addForm" :rules="addRules" ref="addForm" label-width="70px" class="demo-ruleForm">
          <el-form-item label="参与人" prop="name">
            <el-input v-model="addForm.name" placeholder="请输入参与人姓名"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="height: 50px">
        <el-row style="margin: 0 20px">
          <el-col :span="12">
            <div class="cancel-btn" @click="addShow = !addShow">
              <span>取消</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="getParticipant('addForm')">
              <span>确定</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {addelderlyentertainments, updateelderlyentertainments, uploadfile} from '../../../api/yanglaoyuan'
import {querycommunitybyorgids} from '../../../api/organizer'
import {queryhomebycids} from '../../../api/relation'

export default {
  name: 'addEditActive',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      moduletag: '',
      nameshow: '活动名称',
      timeshow: '活动时间',
      descshow: '活动内容',
      nameArr: ['消防演习', '消防培训', '餐厅消毒', '排查隐患', '食堂安全自检', '危险源', '电气', '用火、动火', '用电防火安全', '其他'],
      nametype: '',
      pickerOptions: {},
      inputVisible: false,
      inputValue: '',
      labelCommunity: '',
      labelHome: '',
      treeData: [], // 组织
      orgcommunitys: [], // 小区
      selectorghomes: [], // 家庭
      addEditForm: {
        id: '',
        entertainment_tag: '', // 1 活动记录（老人活动） 2 安全活动记录 （安全活动 ） 3 消防类活动
        'eid': 0,
        'event_time': '',
        'name': '',
        'participants': '',
        participantArr: [],
        'location': '',
        'desc': '',
        'sign_picture': '',
        'live_picture': '',
        'plan_picture': '',
        'promoter': '',
        'recorder': '',
        'department': '',
        orgid: '',
        cid: '',
        hid: ''
      },
      addEditRules: {
        event_time: [
          {required: true, message: '请选择日期', trigger: 'change'}
        ],
        desc: [
          {required: true, message: '请输入内容', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
        location: [
          {required: true, message: '请输入地点', trigger: 'blur'}
        ],
        promoter: [
          {required: true, message: '请输入召集人', trigger: 'blur'}
        ],
        recorder: [
          {required: true, message: '请输入记录人', trigger: 'blur'}
        ],
        participantArr: [
          {required: true, message: '请添加参与人', trigger: 'blur'}
        ]
      },
      addShow: false,
      addForm: {
        name: ''
      },
      addRules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ]
      },
      // 签到照片
      dialogImageUrl: '',
      dialogImageUrlArray: [],
      hideUpload: false,
      dialogVisible: false,
      // 现场照片
      dialogImageUrl1: '',
      dialogImageUrlArray1: [],
      hideUpload1: false,
      dialogVisible1: false,
      // 计划方案
      dialogImageUrl2: '',
      dialogImageUrlArray2: [],
      hideUpload2: false,
      dialogVisible2: false
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    this.getModuleTag()
    this.treeData = this.addEditObj.treeData
    if (this.addEditObj.isAdd) {
      this.addEditForm.eid = this.$store.state.user.LoginResp.entity_id
      this.addEditForm.entertainment_tag = this.addEditObj.entertainment_tag
    } else {
      this.addEditForm.id = this.addEditObj.row.id
      this.addEditForm.entertainment_tag = this.addEditObj.row.entertainment_tag
      this.addEditForm.eid = this.addEditObj.row.eid
      this.addEditForm.event_time = this.addEditObj.row.event_time
      this.addEditForm.name = this.addEditObj.row.name
      if (this.nameArr.indexOf(this.addEditForm.name) === -1) {
        this.nametype = '其他'
      } else {
        this.nametype = this.addEditForm.name
      }
      if (this.addEditObj.row.participants !== '') {
        this.addEditForm.participantArr = this.addEditObj.row.participants.split(',')
      }
      this.addEditForm.location = this.addEditObj.row.location
      this.addEditForm.desc = this.addEditObj.row.desc
      this.dialogImageUrlArray = this.clone(this.addEditObj.row.sign_picture)
      this.dialogImageUrlArray1 = this.clone(this.addEditObj.row.live_picture)
      this.dialogImageUrlArray2 = this.clone(this.addEditObj.row.plan_picture)
      this.addEditForm.promoter = this.addEditObj.row.promoter
      this.addEditForm.recorder = this.addEditObj.row.recorder
      this.addEditForm.department = this.addEditObj.row.department
      this.addEditForm.orgid = this.addEditObj.row.orgid === 0 ? '' : this.addEditObj.row.orgid
      this.addEditForm.cid = this.addEditObj.row.cid === 0 ? '' : this.addEditObj.row.cid
      this.addEditForm.hid = this.addEditObj.row.hid === 0 ? '' : this.addEditObj.row.hid
      if (this.addEditForm.orgid !== '') {
        this.selectOrgId1(this.addEditForm.orgid)
      }
      if (this.addEditForm.cid !== '') {
        this.selectCommunityID1(this.addEditForm.cid)
      }
    }
    if (this.addEditForm.entertainment_tag === 1) {
      this.nameshow = '活动名称'
      this.timeshow = '活动时间'
      this.descshow = '活动内容'
      this.nameArr = ['舞蹈', '唱歌', '画画', '打麻将', '其他']
    } else if (this.addEditForm.entertainment_tag === 2) {
      this.nameshow = '消防活动名称'
      this.timeshow = '消防活动时间'
      this.descshow = '消防活动内容'
      this.nameArr = ['危险源', '电气', '用火、动火', '用电防火安全', '其他']
    }
  },
  methods: {
    getModuleTag () {
      if (this.moduletag === 1) {
        this.labelCommunity = '小区'
        this.labelHome = '家庭'
      } else if (this.moduletag === 2) {
        this.labelCommunity = '机构'
        this.labelHome = '房间'
      } else { // 0
        this.labelCommunity = '小区/机构'
        this.labelHome = '家庭/房间'
      }
    },
    selectOrgId1 (id) {
      let data = {
        orgids: [id]
      }
      querycommunitybyorgids(data).then(res => {
        this.orgcommunitys = res.data.communitys
      }).catch(() => {})
    },
    selectOrgId (id) {
      this.addEditForm.cid = ''
      this.addEditForm.hid = ''
      let data = {
        orgids: [id]
      }
      querycommunitybyorgids(data).then(res => {
        this.orgcommunitys = res.data.communitys
      }).catch(() => {})
    },
    selectCommunityID1 (id) {
      let data = {
        cids: [id]
      }
      queryhomebycids(data).then(res => {
        this.selectorghomes = res.data.homes
      }).catch(() => {})
    },
    selectCommunityID (id) {
      this.addEditForm.cid = id
      this.addEditForm.hid = ''
      let data = {
        cids: [id]
      }
      queryhomebycids(data).then(res => {
        this.selectorghomes = res.data.homes
      }).catch(() => {})
    },
    // 参与人
    handleClose1 (tag) {
      this.addEditForm.participantArr.splice(this.addEditForm.participantArr.indexOf(tag), 1)
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.addEditForm.participantArr.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    changeName (val) {
      if (val === '其他') {
        this.addEditForm.name = ''
      } else {
        this.addEditForm.name = val
      }
    },
    selectDishOpen () {
      this.addForm = {name: ''}
      this.addShow = true
    },
    getParticipant (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let isHave = false
          for (let i = 0; i < this.addEditForm.participantArr.length; i++) {
            if (this.addForm.name === this.addEditForm.participantArr[i].name) {
              isHave = true
              this.$message({
                message: '已有参与人。',
                type: 'warning'
              })
              return
            }
          }
          if (!isHave) {
            this.addEditForm.participantArr.push(this.addForm)
            this.addShow = false
          }
        }
      })
    },
    // 上传图片
    handleSuccess (res, file, fileList) {
      this.$message.success('上传成功')
    },
    // eslint-disable-next-line handle-callback-err
    handleError (err, file, fileList) {
      this.$message.error('上传失败')
    },
    // 签到照片
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove (file, fileList) {
      for (let i = 0; i < this.dialogImageUrlArray.length; i++) {
        if (this.dialogImageUrlArray[i].url === file.url) {
          this.dialogImageUrlArray.remove(this.dialogImageUrlArray[i])
        }
      }
    },
    handleChange (file, fileList) {
      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传头像图片只能是 .png .jpeg .jpg 格式!')
        return
      }
      let obj = {
        raw: file.raw,
        filename: '签到照片',
        domain: window.location.host.indexOf('localhost') === 0 ? 'https://jiaold.com' : window.location.protocol + '//' + window.location.host
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadfile(obj).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传图片', type: 'success' })
        file.filename = res.data.filename
        this.dialogImageUrlArray.push(file)
      }).catch(() => {
        this.$message.closeAll()
        this.$refs.upload.uploadFiles = this.dialogImageUrlArray
        this.$message({ message: '上传图片失败', type: 'error' })
      })
    },
    // 现场照片
    handlePictureCardPreview1 (file) {
      this.dialogImageUrl1 = file.url
      this.dialogVisible1 = true
    },
    handleRemove1 (file, fileList) {
      for (let i = 0; i < this.dialogImageUrlArray1.length; i++) {
        if (this.dialogImageUrlArray1[i].url === file.url) {
          this.dialogImageUrlArray1.remove(this.dialogImageUrlArray1[i])
        }
      }
    },
    handleChange1 (file, fileList) {
      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传头像图片只能是 .png .jpeg .jpg 格式!')
        return
      }
      let obj = {
        raw: file.raw,
        filename: '现场照片',
        domain: window.location.host.indexOf('localhost') === 0 ? 'https://jiaold.com' : window.location.protocol + '//' + window.location.host
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadfile(obj).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传图片', type: 'success' })
        file.filename = res.data.filename
        this.dialogImageUrlArray1.push(file)
      }).catch(() => {
        this.$message.closeAll()
        this.$refs.upload1.uploadFiles = this.dialogImageUrlArray1
        this.$message({ message: '上传图片失败', type: 'error' })
      })
    },
    // 计划方案照片
    handlePictureCardPreview2 (file) {
      this.dialogImageUrl2 = file.url
      this.dialogVisible2 = true
    },
    handleRemove2 (file, fileList) {
      for (let i = 0; i < this.dialogImageUrlArray2.length; i++) {
        if (this.dialogImageUrlArray2[i].url === file.url) {
          this.dialogImageUrlArray2.remove(this.dialogImageUrlArray2[i])
        }
      }
    },
    handleChange2 (file, fileList) {
      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传头像图片只能是 .png .jpeg .jpg 格式!')
        return
      }
      let obj = {
        raw: file.raw,
        filename: '计划方案照片',
        domain: window.location.host.indexOf('localhost') === 0 ? 'https://jiaold.com' : window.location.protocol + '//' + window.location.host
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadfile(obj).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传图片', type: 'success' })
        file.filename = res.data.filename
        this.dialogImageUrlArray2.push(file)
      }).catch(() => {
        this.$message.closeAll()
        this.$refs.upload2.uploadFiles = this.dialogImageUrlArray2
        this.$message({ message: '上传图片失败', type: 'error' })
      })
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addEditForm.name === '') {
            this.$message({
              message: '请输入安全名称。',
              type: 'warning'
            })
            return
          }
          let signpicture = ''
          let livepicture = ''
          let planpicture = ''
          for (let i = 0; i < this.dialogImageUrlArray.length; i++) {
            signpicture = signpicture === '' ? this.dialogImageUrlArray[i].filename : (signpicture + ',' + this.dialogImageUrlArray[i].filename)
          }
          for (let i = 0; i < this.dialogImageUrlArray1.length; i++) {
            livepicture = livepicture === '' ? this.dialogImageUrlArray1[i].filename : (livepicture + ',' + this.dialogImageUrlArray1[i].filename)
          }
          for (let i = 0; i < this.dialogImageUrlArray2.length; i++) {
            planpicture = planpicture === '' ? this.dialogImageUrlArray2[i].filename : (planpicture + ',' + this.dialogImageUrlArray2[i].filename)
          }
          let participants = ''
          for (let i = 0; i < this.addEditForm.participantArr.length; i++) {
            participants = participants === '' ? this.addEditForm.participantArr[i] : (participants + ',' + this.addEditForm.participantArr[i])
          }
          // console.log(signpicture, livepicture, planpicture)
          // return
          if (this.addEditObj.isAdd) {
            let data = {
              entertainment_tag: this.addEditForm.entertainment_tag,
              eid: this.addEditForm.eid,
              event_time: this.addEditForm.event_time,
              name: this.addEditForm.name,
              participants: participants,
              location: this.addEditForm.location,
              desc: this.addEditForm.desc,
              sign_picture: signpicture,
              live_picture: livepicture,
              plan_picture: planpicture,
              promoter: this.addEditForm.promoter,
              recorder: this.addEditForm.recorder,
              department: this.addEditForm.department,
              orgid: this.addEditForm.orgid !== '' ? this.addEditForm.orgid : this.$store.state.user.orgid,
              cid: this.addEditForm.cid !== '' ? this.addEditForm.cid : 0,
              hid: this.addEditForm.hid !== '' ? this.addEditForm.hid : 0
            }
            addelderlyentertainments(data).then(res => {
              this.$notify({title: '成功', message: '成功新增', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            let data = {
              id: this.addEditForm.id,
              entertainment_tag: this.addEditForm.entertainment_tag,
              eid: this.addEditForm.eid,
              event_time: this.addEditForm.event_time,
              name: this.addEditForm.name,
              participants: participants,
              location: this.addEditForm.location,
              desc: this.addEditForm.desc,
              sign_picture: signpicture,
              live_picture: livepicture,
              plan_picture: planpicture,
              promoter: this.addEditForm.promoter,
              recorder: this.addEditForm.recorder,
              department: this.addEditForm.department,
              orgid: this.addEditForm.orgid !== '' ? this.addEditForm.orgid : this.$store.state.user.orgid,
              cid: this.addEditForm.cid !== '' ? this.addEditForm.cid : 0,
              hid: this.addEditForm.hid !== '' ? this.addEditForm.hid : 0
            }
            updateelderlyentertainments(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditActive.vue